<template>

    <ValidationObserver v-slot="{ handleSubmit, valid }" ref="mainObserver">
        <form
            name="myf2g-login-mobile-form"
            id="myf2g-login-mobile-form"
            @submit.prevent="handleSubmit(submitForm)"
        >
            <div class="descr-login-telephone" style="margin-bottom:15px;">
                {{ words['myf2g.login.mobileform.description'] }}
            </div>
            <div >
                <ValidationProvider name="msisdn" rules="required|msisdn"  v-slot="{ errors, validated, invalid }">
                    <div class="form-field">
                        <label class="form-label" for="first">{{ words['myf2g.login.mobileform.mobile.label'] }}</label>
                        <input type="text" id="msisdn-input" class="overlay-input-text form-input" v-model="msisdn" />
                        <template v-if="validated && invalid">
                            <span style="color:#FE4C6F;">{{ errors[0] }}</span>
                        </template>
                        <template v-else-if="responseErrorLevel != 0 && responseErrorCode != 14007">
                            <span style="color:#FE4C6F;" v-html="responseErrorMessage"></span>
                        </template>
                        <template v-else>
                            <div id="captcha-box" v-show="captchaVersion=='v2'" style="margin-top:20px;">
                              <div id="captchaTest"></div>
                              <div class="row">
                                <div class="col-md-6 col-xs-12">
                                  <p class="error" style="color:#FE4C6F;"><span class="field-validation-error"></span></p>
                                </div>
                              </div>
                            </div>
                        </template>

                    </div>
                </ValidationProvider>
                <div class="text-align-center button-login-f2g">
                    <div class="overlay-button-container button-register">
                        <input id="myf2g-mobile-login" name="myf2g-mobile-login" type="submit" class="container-button" :class="[valid ? 'blue-btn' : 'grey-btn']" :disabled="!valid" :value="words['myf2g.login.mobileform.submit.button']" />
                    </div>
                </div>
            </div>
        </form>
    </ValidationObserver>

</template>

<script>
import store from '../store/store'
import router from '../router/router'
import _ from 'lodash'

export default {
  name: 'MobileForm',
  data: function() {
      return {
          words: {},
          msisdn:'',
          responseErrorLevel: 0,
          responseErrorMessage: '',
          responseErrorCode : 0,
          captchaVersion: 'v3',
          widgetId: '',
          validatedOnce: false,
          isComponentLoaded: false
      }
  },
  computed: {
      tai() {
        return store.state.tai;
      },
      locale() {
          return store.state.locale;
      },
      mobileFormWords() {
          return store.state.mobileFormWords;
      },
      captchaKeyV3() {
      return document.getElementsByTagName("body")[0].getAttribute("data-captchav3");
    }

  },
  watch: {
    msisdn() {

      if (this.responseErrorLevel != 0) {
        this.responseErrorLevel = 0;
        this.responseErrorMessage = "";
        this.responseErrorCode = 0;
      }

      var self = this;
      if (!this.validatedOnce) {
        if (this.msisdn.length == 10) {
          this.$refs.mainObserver.validate().then(function(response){
            self.validatedOnce = true;
          })
        }
      } else {
        this.$refs.mainObserver.validate();
      }
    },
    isComponentLoaded() {
        console.log("isComponentLoaded: "+this.isComponentLoaded);
        if (this.isComponentLoaded) {
            var self = this;
            this.$nextTick(function(){
                console.log("nexttick called");
                self.bindJSFunctionality();
            })
        }
    }

  },
  beforeMount() {
    
    if ( sessionStorage.getItem("wcs_myf2gloginmobileform_"+this.locale) != null ) {
      this.words = JSON.parse(sessionStorage.getItem("wcs_myf2gloginmobileform_"+this.locale));
      this.isComponentLoaded = true;
    } else {
      
      let config = {
        method: 'get',
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2gloginmobileform',
          locale: this.locale,
        }
      }
      
      let self = this;
      this.axios(config).then(function(response){
        console.log(response);
        self.words = response.data;
        sessionStorage.setItem("wcs_myf2gloginmobileform_"+self.locale, JSON.stringify(self.words));
        self.isComponentLoaded = true;
        
      }).catch(function(error){
        console.error(error);
      })

    }
    
  },
  methods: {
      submitForm() {
          

      if ( this.validateCaptcha() ) {

        //construct the request
        let request = {}

        //construct the caller
        request.caller = {};
        request.caller.callingSystem = "myF2Gweb";
        request.caller.salesCode = "";
        request.caller.username = "anonymous";
        request.caller.locale = this.locale;
        request.caller.channel = "F2G";
      
        //construct the request info
        request.msisdn = this.msisdn;
        request.tai = this.tai;


        //Show loading spinner
        
        let self = this;

        grecaptcha.ready(function() {
          grecaptcha.execute(self.captchaKeyV3, {action: 'callMsisdnValidityCheck'}).then(function(token){
            request.captchaToken = token;

            if (self.captchaVersion == "v2") {
                request.captchaToken = grecaptcha.getResponse(self.widgetId);
            }

            request.captchaVersion = self.captchaVersion;

            //construct the axios configuration
            let config = {
              method: 'post',
              url: '/apiv2/login/msisdnValidityCheck/',
              data: request
            }

            var self2 = self;

            self.axios(config).then(function(response){
              console.log(response);

              if (response.data.errorLevel == 0) {

                  //Handle Success response
                  store.commit("msisdn", self2.msisdn);
                  store.commit("step1Visited", true);
                  store.commit("isSilentRegistration", response.data.displayEmailInputField);

                  router.push({name: 'loginOptionStep2'})

              } else if (response.data.errorCode == 14007) {

                if (self2.captchaVersion != "v2") {
                  var v2Key = document.getElementsByTagName("body")[0].dataset.captchav2;
                  grecaptcha.ready(() => {
                    self2.widgetId = grecaptcha.render('captchaTest', {
                      'sitekey' : v2Key,
                      'theme' : 'dark'
                    });
                  });
                }
                self.captchaVersion = "v2";

              } else {
                
                //Handle Error Level 1
                self2.responseErrorLevel = response.data.errorLevel;
                self2.responseErrorMessage = response.data.errorMessage;
              }

              
            }).catch(function(error){
              console.error(error);
            }).then(function(){
                //Hide spinner
            })

          })
        })
      }
    },
    validateCaptcha() {
      if (this.captchaVersion == "v2" && grecaptcha.getResponse(this.widgetId).length == 0) {
        $('body').data('locale') == "el_GR" ? 
          $('#captcha-box > div > div > p > span').html('To captcha πρέπει να συμπληρωθεί.') :
          $('#captcha-box > div > div > p > span').html('Please fill in the captcha.');
        $("#captcha-box > div > div > p > span").show();
      } else {
        $('#captcha-box > div > div > p > span').html('') 
        $("#captcha-box > div > div > p > span").hide();
      }
      return this.captchaVersion == "v3" || grecaptcha.getResponse(this.widgetId).length != 0;
    },
    bindJSFunctionality() {

        console.log("bindJSFunctionality called");

        $('input').focus(function(){
          $(this).parents('.form-field').addClass('focused');
        });
        
        $('input').blur(function(){
          var inputValue = $(this).val();
          if ( inputValue == "" ) {
          $(this).removeClass('filled');
          $(this).parents('.form-field').removeClass('focused');  
          } else {
          $(this).addClass('filled');
          }
        })

        console.log("focus-blur bind");
    }

  }
}
</script>

